// Exposes the typed client to legacy jQuery code (js/calendar.v2.8.js is loaded as a plain <script>,
// not part of this esbuild bundle, so it can only reach these modules through a window global).
import * as api from "./calendar-api";
import { SessionExpiredError } from "./http-client";

declare global {
  interface Window {
    dispecink?: {
      api: typeof api;
      isSessionExpired: (error: unknown) => boolean;
    };
  }
}

export function installLegacyBridge(): void {
  window.dispecink = {
    api,
    isSessionExpired: (error: unknown) => error instanceof SessionExpiredError,
  };
}
